import { useContext } from "react";
import { Progressbar } from "@utp/react-components-prod";
import { StyledProgressbarWrapper } from "./styled";
import EvaluationContext from "features/Evaluation/context";
import Skeleton from "./components/Skeleton";
import { Tooltip } from "./components/ToolTip";

interface IProgressbarProps {
  isMinorTablet: boolean;
}

export const ProgressBar = ({ isMinorTablet }: IProgressbarProps) => {
  const { allQuestions, question, isErrorRemaining } =
    useContext(EvaluationContext);
  const divContainer = `flex-1 flex justify-center ${
    isMinorTablet ? "w-full" : ""
  }`;

  const divContainerProgress = `${isMinorTablet ? "w-full" : "w-352"}`;

  const handleGetProgress = () => {
    const questionResponse = question.order - 1;
    const percentage = (questionResponse / allQuestions) * 100;
    return isErrorRemaining ? 0 : percentage;
  };

  return (
    <div className={divContainer} data-testid="progress-bar">
      <div className={divContainerProgress}>
        {!isErrorRemaining ? (
          <Tooltip
            isMinorTablet={isMinorTablet}
            order={question.order}
            allQuestions={allQuestions}
          />
        ) : (
          <Skeleton />
        )}
        <StyledProgressbarWrapper className="mt-5">
          <Progressbar
            label=""
            showProgress={false}
            progress={handleGetProgress()}
          />
        </StyledProgressbarWrapper>
      </div>
    </div>
  );
};
